import { NextUrqlPageContext } from 'next-urql/dist/types/types'
import { compose } from 'ramda'
import { isAuthenticatedClient, isAuthenticatedServer } from 'lib/auth'
import { isServerSide } from 'lib/env'
import { gqlErrorToStatusCode } from 'lib/error'
import { withCookies } from 'hocs/withCookies'
import { withGql } from 'hocs/withGql'
import withVertical from 'hocs/withVertical'
import { AnalyticsProvider } from 'hooks/useAnalytics'
import { MeWithRefetchProvider } from 'hooks/useMe'
import { SHARED_QUERY_JOB } from 'containers/upsert-job/queries'
import { parseParams } from 'containers/job/hooks/useParams'
import { Page } from 'containers/job/page'
import { WithTrackingPixels } from 'containers/job/tracking-pixels/context/WithTrackingPixels'

const PageWrapper = ({ isAuthenticated }: { isAuthenticated?: boolean }) => {
    return (
        <WithTrackingPixels>
            <MeWithRefetchProvider isAuthenticated={Boolean(isAuthenticated)}>
                <AnalyticsProvider
                    pageNameForAnalytics={'Job'}
                    pageVersionForAnalytics={'2'}
                >
                    <Page />
                </AnalyticsProvider>
            </MeWithRefetchProvider>
        </WithTrackingPixels>
    )
}

async function setProperStatusCodeIfSSR(ctx: NextUrqlPageContext) {
    if (isServerSide) {
        const params = parseParams(ctx.query)

        // it's the same query as in the page, so we query it one time per page render
        const res = await ctx.urqlClient
            .query(SHARED_QUERY_JOB, { slug: params.slug })
            .toPromise()

        const statusCode = gqlErrorToStatusCode(res.error)
        if (statusCode) {
            // @ts-ignore
            ctx.res.statusCode = statusCode
        }
    }
}

PageWrapper.getInitialProps = async (ctx: NextUrqlPageContext) => {
    // TODO: Main suspect for constant sporadic error on this page (see '#dev-prod-errors' in Slack).
    await setProperStatusCodeIfSSR(ctx)

    return {
        isAuthenticated: isServerSide
            ? isAuthenticatedServer(ctx)
            : isAuthenticatedClient(),
    }
}

export default compose(
    withGql({
        normalizedCacheOptions: {
            keys: {
                Affiliate: (c: any) => {
                    return c.url
                },
            },
        },
    }),
    withVertical,
    withCookies,
)(PageWrapper)
